import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

class ToolTip extends Component {
  static onFocus(e) {
    e.preventDefault();
  }

  static onBlur(e) {
    e.preventDefault();
  }

  constructor(props) {
    super(props);

    this.hideTimeout = null;
    this.onClick = this.onClick.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this.state = {
      show: false,
    };
  }

  onClick(e) {
    e.preventDefault();
    this.toggle();
  }

  onMouseOver() {
    this.show();
  }

  onMouseOut() {
    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, 400);
  }

  toggle() {
    clearTimeout(this.hideTimeout);
    this.setState({
      show: !this.state.show,
    });
  }

  show() {
    clearTimeout(this.hideTimeout);
    this.setState({
      show: true,
    });
  }

  hide() {
    this.setState({
      show: false,
    });
  }

  render() {
    let classname = 'tooltip';

    if (this.state.show) classname += ' tooltip--show';

    return (
      <span
        className={classname}
        onClick={this.onClick}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        role="presentation"
        onKeyUp={this.focus}
        tabIndex="-1"
      >
        {this.props.children}
        <span className="tooltip__content">{this.props.text}</span>
      </span>
    );
  }
}

ToolTip.propTypes = {
  children: PropTypes.element.isRequired,
  text: PropTypes.string.isRequired,
};

export default ToolTip;



// WEBPACK FOOTER //
// ./src/components/ToolTip/index.jsx